import { $, ww, findTarget, findParent } from '../utils/Utils';

/* This script deals with the transition within the mobile menu
 * and shows the correct menu level on opening
 * if you're after the opening/closing of the menu itself,
 * check menu.js - where the opening/closing for both the desktop and mobile
 * menu is handled.
 */

const menuMobile = (() => {
  const config = {
    menu: $('.js-menuMobile')[0],
    back: $('.js-menuMobileBack')[0],
    subMenuTriggerButton: [...$('.js-menuMobileSubMenuTrigger')],

    listItemCN: 'js-menuMobileListItem',
    linkCN: 'js-menuMobileLink',
    navCN: 'js-menuMobileSubNav',
    headingCN: '-heading',

    listItem: [...$('.js-menuMobileListItem')],
    navs: [...$('.js-menuMobileSubNav')],
    expandedCN: '-expanded',
    activeCN: '-active',
    hideCN: '-hide',
    showCN: '-show',
    hasChildrenCN: '-has-children'
  };

  const back = {
    show() {
      // remove aria attribute
      config.back.removeAttribute('aria-hidden');
      // show button
      config.back.classList.add(config.showCN);
      // accessibility: focus on the back button
      config.back.focus();
    },
    hide() {
      config.back.setAttribute('aria-hidden', true);
      config.back.classList.remove(config.showCN);
      // accessibility: focus on the X (close) button
      config.menu.querySelector('.js-menuDismiss').focus();
    },
  };

  const link = {
    state(s, element) {
      switch (s) {
        case 'heading':
          // add classname
          element.classList.add(config.headingCN);
          break;
        case 'reset':
          // get all links with heading classname
          const heading = [...config.menu.querySelectorAll(`.${config.headingCN}`)];
          if (heading.length > 0) {
            // remove the classname
            heading.forEach(h => h.classList.remove(config.headingCN));
          }
          break;

        default:
          break;
      }
    },
    current() {
      return config.menu.querySelector(`.${config.activeCN}`);
    },
    activateCurrent() {
      const currentLink = link.current();
      if(currentLink) {
        config.menu.querySelectorAll(`.${config.linkCN}.-has-active`).forEach(function (linkItem) {
          handleClick({e:false, trigger: linkItem});
        })
        if(currentLink.parentElement.classList.contains(config.hasChildrenCN))
          handleClick({e:false, trigger: currentLink});
      }
    }
  };

  const level = {
    show(lvl, element) {
      if (lvl > 1) {
        // show level 2+
        // we'll find the target ul.-level2 (submenu)

        const targetSubMenu = findTarget({
          element,
          parent: config.listItemCN,
          target: config.navCN,
        });
        // show the counterpart submenu
        targetSubMenu.classList.remove(config.hideCN);
        // remove aria attribute
        targetSubMenu.removeAttribute('aria-hidden');
      } else {
        // show level 1
        config.listItem.forEach((item) => {
          item.classList.remove(config.hideCN);
          item.removeAttribute('aria-hidden');
        });
      }
    },
    hide(lvl, element) {
      if (lvl > 1) {
        // hide level 2+
        config.navs.forEach((menuLevel) => {
          menuLevel.classList.add(config.hideCN);
          menuLevel.setAttribute('aria-hidden', 'true');
        });
      } else {
        // get the element parent = <li> listItem
        const listItem = findParent(element, config.listItemCN);
        // get all of the same level listItem except the trigger
        const itemsToHide = config.listItem.filter(item => item !== listItem);
        // hide items
        itemsToHide.forEach((item) => {
          item.classList.add(config.hideCN);
          item.setAttribute('aria-hidden', 'true');
        });
      }
    },
  };


  const handleReset = (e = false) => {
    if (e) {
      e.preventDefault();
    }
    // hide the 'back' button
    back.hide();
    // hide menu level 2+
    level.hide(2);
    // reset the state of the link that was put at the top of the submenu
    link.state('reset');
    // show menu level 1
    level.show(1);
  };

  const handleClick = ({ e, trigger }) => {
    const subMenu = findParent(
      trigger,
      config.listItemCN
    );
    // prevent default in case
    if(e)
      e.preventDefault();

    const lvl = parseInt(subMenu.dataset.level);
    const itemsToHide = subMenu.parentElement.querySelectorAll(`.${config.listItemCN}.-level${lvl}`);
    itemsToHide.forEach((item) => {
      if(item != subMenu) {
        item.classList.add(config.hideCN);
        item.setAttribute('aria-hidden', 'true');
      }
    });

    subMenu.querySelector(`.${config.linkCN}`).classList.add(config.headingCN);
    const nextUl = subMenu.querySelector(`.${config.navCN}.-level${lvl+1}`);
    if(nextUl) {
      nextUl.classList.remove(config.hideCN);
      nextUl.setAttribute('aria-hidden', false);
      nextUl.querySelectorAll(`.${config.listItemCN}.-level${lvl+1}`).forEach((item) => {
        item.classList.remove(config.hideCN);
        item.setAttribute('aria-hidden', false);
      });
    }

    // show 'back' button
    back.show();
  };

  const build = () => {
    // handle the transitions on clicking the >
    config.subMenuTriggerButton.forEach((trigger) => {
      trigger.addEventListener('click', e => handleClick({ trigger, e }));
    });

    // go back to first menu on clicking the 'back' button
    config.back.addEventListener('click', e => handleReset(e));

    link.activateCurrent();

  };

  const init = () => {
    if (config.menu) {
      build();
    }
  };

  return {
    init,
  };
})();

export default menuMobile.init();


/**
 *
 * Ändra avbokningspolicy akademirummet & grythytans vinskänksal
 *
 *
 */
